import React, {useState} from 'react';
import '../parseller/./gallery.css';
import '../parseller/parselDetail.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import CloseIcon from '@mui/icons-material/Close';
import { Container,Box,Paper,Grid,Typography } from '@mui/material';
import Svgyuzellibireotuziki from '../components1/Svgyuzellibireotuziki';
import Registration from '../components/Registration';
import rsm1014 from '../imageproje/151-32/00.avif';
import img1 from '../imageproje/151-32/02a.avif';
import img2  from '../imageproje/151-32/01.avif';
import img3  from '../imageproje/151-32/02.avif';
import img4  from '../imageproje/151-32/03.avif';
import img5  from '../imageproje/151-32/04.avif';
import img6  from '../imageproje/151-32/05.avif';
import img7  from '../imageproje/151-32/06.avif';
import img8  from '../imageproje/151-32/07.avif';
import img9  from '../imageproje/151-32/01a.avif';
import Comunication from '../components/Comunication';
import ComunicationPhone from '../components/ComunicationPhone';
import ComunicationEmail from '../components/ComunicationEmail';

function createData(il, ilce, Koy, ada, parsel, ozel, metraj, birim) {
    return { il, ilce, Koy,ada, parsel, ozel, metraj, birim };
  }

const Byuzellibireotuziki = () => {
    const [model, setModel] = useState(false);
    const [tempimgSrc, setTempimgSrc] = useState('');
    const getImg = (imgSrc) => {
        setTempimgSrc(imgSrc);
        setModel(true);
    }
  return (
    <>
        <Comunication/>
        <ComunicationPhone/>
        <ComunicationEmail/>
        <img src={rsm1014} alt="Belgrat Mahallesi" style={{width:'100%',marginTop:'83PX'}} loading='lazy'/>
        <Container className='parselWriting'>
            <Typography variant='h5' component='h5' sx={{marginTop:3}}>
                İstanbul, Çatalca, Belgrat Mahallesi, Lozan 1 Projesi
            </Typography>
            <Typography variant='body1' component='p' sx={{marginTop:3}}>
                İstanbul ilinin Çatalca ilçesine bağlı Belgrat Mahallesi'nde yer alan bu özel proje, 2 adet parselden oluşmaktadır. Parsellerin tamamı yerleri belli, parsel 522.05 m² dir. Bu parsel kadastral yol hemen parselin başındadır.
                <br/>
                <br/>
                Projemiz, İstanbul bölgesinin hem turistik hem de tarımsal ve sanayi açısından gözde ilçelerinden biri olan Çatalcanın'ın Belgrat Mahallesi yerleşimine yürüme mesafesinde konumlanmıştır. Çatalca ilçe merkezine 35 km, İstanbul il merkezine 75 km, Çatalca guzide plajlarından Yalıköye'e 15 km, Karacaköy Evcik Plajına 5 km, Ormanlı Plajına 8 km ve Çilingoza'ya 25 km, uzaklıktadır. 
                <br/>
                <br/>
                İstanbul şehir merkezine yakın olduğundan ulaşımı kolaydır. Arazinize yaz, kış rahatlıkla ulaşabilirsiniz. Günlük olarak gelebilir, meşe ormanlarının dibinde, kuş cıvıltıları içinde dinlenebilir ve takip eden günde işinize dinlenik olarak gidebilirsiniz.
                <br/>
                <br/>
                Bu eşsiz projede, doğanın ve huzurun tadını çıkarırken modern yaşamın tüm olanaklarına sahip olabilirsiniz!
            </Typography>
        </Container>
        <Container fixed sx={{marginTop:3, marginBottom:3}}>
            <Grid className='parselSvg' sx={{display:'flex', justifyContent:'space-around', alignContent:'center'}} gap={2}>
                <Box sx={{width:'50%'}}>
                    <Paper elevation={8} sx={{width:'100%'}}>
                        <Svgyuzellibireotuziki/>
                    </Paper>
                </Box>
                <Box className='boxToTable'>
                    <TableContainer elevation={8} sx={{width:'100%', overflow:'hidden'}}component={Paper}>
                        <Table className='tableStyle'>
                            <TableHead className='tableHeadStyle'>
                            <TableRow>
                                <TableCell>İl</TableCell>
                                <TableCell>İlçe</TableCell>
                                <TableCell>Köy</TableCell>
                                <TableCell>Ada</TableCell>
                                <TableCell>Parsel</TableCell>
                                <TableCell>Özel Parsel</TableCell>
                                <TableCell align="right">Miktar</TableCell>
                                <TableCell>Birim</TableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody>
                            {rows.map((row, key) => (
                                <TableRow
                                key={key}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                <TableCell component="th" scope="row">{row.il}</TableCell>
                                <TableCell component="th" scope="row">{row.ilce}</TableCell>
                                <TableCell component="th" scope="row">{row.Koy}</TableCell>
                                <TableCell align="right">{row.ada}</TableCell>
                                <TableCell align="right">{row.parsel}</TableCell>
                                <TableCell align="right">{row.ozel}</TableCell>
                                <TableCell align="right">{row.metraj}</TableCell>
                                <TableCell align="right">{row.birim}</TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <div className='parselSorguGit'>
                        <a href="https://parselsorgu.tkgm.gov.tr/#ara/idari/146003/151/32/1741640900677">Parsel Sorguya Git</a>
                    </div>
                </Box>
            </Grid>
        </Container>
        <Container>
            <Typography variant='h5' component='h5'style={{textAlign:'center',marginBottom:'20px'}}>
            PROJE AİT GÖRSELLER
            </Typography>
        </Container>
        <Container>
            <div className={model ? "model open" : "model"} >
                <img src={tempimgSrc} alt='Çatalca'loading='lazy'/>
                <CloseIcon onClick={() => setModel(false)}/>
            </div>
        </Container>
        <Container>
            <div className='gallery galaryList'>
                {DataItem1051.map((item, index) =>{
                    return(
                        <div className='pics' key={index} onClick={() => getImg(item.imgSrc)}>
                            <img src={item.imgSrc} alt='Çatalca' style={{width:'100%'}} loading='lazy'/>
                        </div>
                    )
                })}
            </div>
        </Container>
        <Container>
            <iframe src="https://www.google.com/maps/d/u/0/embed?mid=1WTYwVE13O1ACLtlzwqjLZhzybZo6HGY&ehbc=2E312F&noprof=1" width="100%" height="480"></iframe>
        </Container>
    </>   
  )
}

export default Byuzellibireotuziki;

const DataItem1051 = [
    {   id:1, imgSrc:img1},
    {   id:2, imgSrc:img2},
    {   id:3, imgSrc:img3},
    {   id:4, imgSrc:img4},
    {   id:5, imgSrc:img5},
    {   id:6, imgSrc:img6},
    {   id:7, imgSrc:img7},
    {   id:8, imgSrc:img8},
    {   id:9, imgSrc:img9},
];

const rows = [
    createData('İstanbul','Çatalca','Belgrat','151', '32','P04',522, 'm²'),
    createData('İstanbul','Çatalca','Belgrat','151', '32','P05',522, 'm²'),
    createData('İstanbul','Çatalca','Belgrat','151', '32','P06',522, 'm²'),
  ];